import { createFileRoute } from '@tanstack/react-router';
import { TeamsPage } from '@/features/teams/teams-page';

export const Route = createFileRoute('/w/$workspaceId/settings/teams')({ component: TeamsPage });
